import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate, formatData, getUserNameToName } from '../../../utils/util';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import { Breadcrumbs, Input, Button, Collapsible } from '../../../components/UI/ComponentsUI'
import { validateInputsRequired } from '../../../utils/handleChangeHooks';
import ConfigurationService from '../../../services/ConfigurationService';

const EmailInsert = (props) => {
    const messageModal = useRef();
    const [emails, setEmails] = useState([]);
    const [selectedId, setSelectedId] = useState();
    const [email, setEmail] = useState();

    useEffect(() => {
        props.getEmails();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.emails?.items && props.emails?.items?.length > 0) {
            setEmails([...props.emails.items]);
        } else {
            setEmails([]);
        }
        document.getElementById('email').focus();
        // eslint-disable-next-line
    }, [props?.emails?.items]);

    const openModal = (id) => {
        setSelectedId(id)
        messageModal.current.show();
    }

    const deleteSelectedItem = () => {
        props.deleteEmail(selectedId, () => {
            props.getEmails();
        });
    };

    const add = () => {
        if (validateInputsRequired()) {
            props.addEmail(email, () => {
                setEmail("");
                props.getEmails();
            });
        }
    }

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('config.critical-parts-registration.add-emails', 'container') }} />

            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="addSection"
                        header={translate('general:add')}
                        body={
                            <>
                                <form id="addForm" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s10">
                                            <Input
                                                id="email"
                                                name='email'
                                                label={translate('general:email')}
                                                type="text"
                                                required
                                                value={email || ''}
                                                onChange={(e) => { setEmail(e.currentTarget.value) }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        add();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text={translate("general:add")} onClick={() => add()} />
                                </div>
                            </>
                        }
                    />
                </div>
                {
                    emails.map((item) => {
                        return <div key={item.id} style={{ backgroundColor: '#FFF', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 5px 0px', padding: '4px' }}>
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', right: '15px', marginTop: '5px' }}
                            >
                                <i onClick={() => openModal(item.id)} className="material-icons sixth-text-color" style={{ fontSize: '1.75rem', cursor: 'pointer' }}>delete</i>
                            </span>
                            <span className="title sixth-text-color">{item.email}</span>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                <i className="mdi mdi-history" /> {formatData(item.createOn)}
                            </span>
                            <span className="second-text-color" style={{ marginLeft: '10px' }}>
                                <i className="mdi mdi-account" /> {getUserNameToName(props?.usersFromElog, item.createBy)}
                            </span>
                        </div>
                    })}

            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModalDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={deleteSelectedItem}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        emails: state.configReducer.alertsEmailPaged
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addEmail: (model, callback) => {
            dispatch(ConfigurationService.insertAlertEmail(model, callback));
        },
        getEmails: (vision) => {
            dispatch(ConfigurationService.getAlertEmail(vision));
        },
        deleteEmail: (id, callback) => {
            dispatch(ConfigurationService.deleteAlertEmail(id, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmailInsert));
